import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MdCreditCard } from "react-icons/md";
import { toast } from "react-toastify";
import moment from "moment";
import { GetSingleInvoiceData } from "../../../../StateManagement/Reducers/BillingState";

import InvoicePopup from "./InvoicePopup";
import MakePayment from "../../../StyledComponents/MakePayment";
import EmptyData from "../../../StyledComponents/EmptyData";
import Error from "../../../../Modules/StyledComponents/Toastify/Error";

import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableBodyCell,
} from "../../../StyledComponents";
import { Div } from "../../Styles";
import {
  AvatarFrame,
  AvatarTxt,
  TxtSpan,
  NewStatusBadge,
  NewActionButton,
  NewTableHeadCell,
} from "../styles";
import StripeAlert from "../../../StyledComponents/StripeAlert";

const HEADER_GRID = "17% 14% 13% 11% 11% 13% 21%";

const InvoiceBalance = ({ InvoiceList }) => {
  const dispatch = useDispatch();

  const [invoiceModal, setInvoiceModal] = useState(false);
  const [MakePay, setMakePay] = useState(false);
  const [InvoiceBalanceAmt, setInvoiceBalanceAmt] = useState(0);
  const [OneInvoiceDetail, setOneInvoiceDetail] = useState([]);
  const [invId, setInvId] = useState("");
  const [btnDisable, setBtnDis] = useState(false);
  const [buttonDisable, setButtonDis] = useState(false);
  const [ModalAlerShow, setModalAlerShow] = useState(false);

  const CardDetails = useSelector((state) => state.Billing.CardDetail);
  const stripeAllowed = useSelector((state) => state.Billing.stripeAllowed);

  const DefaultCardDetails = CardDetails.map(
    (card) => card.def === "1" && card.id,
  );

  const ViewInvoice = (InvoiceID) => {
    setButtonDis(true);
    setTimeout(() => {
      setButtonDis(false);
    }, 1000);

    dispatch(GetSingleInvoiceData(InvoiceID));
    setInvId(InvoiceID);
    setInvoiceModal(true);
  };

  const InvoicePayment = (InvoiceID) => {
    if (stripeAllowed === false) {
      setModalAlerShow(true);
      return;
    }

    setBtnDis(true);
    setTimeout(() => {
      setBtnDis(false);
    }, 1000);

    if (CardDetails.length > 0) {
      const OneInvoice = InvoiceList.filter(
        (Invoiceitm) => Invoiceitm.invoice_id === InvoiceID,
      );

      if (OneInvoice.length > 0) {
        setOneInvoiceDetail(OneInvoice);
        setInvoiceBalanceAmt(OneInvoice[0].total_balance);
        setMakePay((prevState) => !prevState);
      }
    } else {
      toast(<Error msg={`Add Your Card Details then Make a Payment`} />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  };

  const handleModalClick = () => {
    setModalAlerShow(false);
  };

  useEffect(() => {
    dispatch(GetSingleInvoiceData());
  }, [dispatch]);

  const getStatus = (row) => {
    const balance = parseFloat(row.total_balance || 0);
    const billed = parseFloat(row.total_amount || row.total_balance || 0);

    if (balance === 0) return "Paid";
    if (balance < billed) return "Partially Paid";
    return "Unpaid";
  };
  const normalizeProviderName = (name) => {
    if (!name || typeof name !== "string") return name;
    return name
      .replace(/\s*,\s*/g, " ")
      .replace(/\s{2,}/g, " ")
      .trim();
  };
  console.log("Data showing in the UI (InvoiceList):", InvoiceList);
  return (
    <Div marginTop="0" style={{ minWidth: "720px" }}>
      <Table height="auto">
        <TableHead>
          <TableRow
            display="grid"
            tempColumns={HEADER_GRID}
            background="#F1F7FF"
          >
            <NewTableHeadCell padding="16px 12px">Provider</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">
              Generated On
            </NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Invoice</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Billed</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Balance</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px" textAlign="center">
              Status
            </NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px" textAlign="center">
              Action
            </NewTableHeadCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {InvoiceList.length !== 0 ? (
            <>
              {InvoiceList.map((row, ind) => (
                <TableRow
                  display="grid"
                  tempColumns={HEADER_GRID}
                  key={ind}
                  alignItems="center"
                  id={`bil_inv-row-${ind}`}
                  style={{ alignItems: "center", minHeight: "54px" }}
                >
                  <TableBodyCell padding="10px 12px">
                    <Div
                      display="flex"
                      alignItems="center"
                      style={{ minWidth: 0 }}
                    >
                      <AvatarFrame
                        style={{
                          width: "18px",
                          height: "18px",
                          marginRight: "8px",
                          flexShrink: 0,
                        }}
                      >
                        <AvatarTxt style={{ fontSize: "10px" }}>
                          {row.invo_fname_split ||
                            (row.providerName
                              ? row.providerName.charAt(0)
                              : "P")}
                        </AvatarTxt>
                      </AvatarFrame>

                      <TxtSpan
                        fontWeight="500"
                        color="#1e293b"
                        style={{
                          display: "inline-block",
                          minWidth: 0,
                          maxWidth: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontSize: "11px",
                          lineHeight: "14px",
                        }}
                        title={row.providerName || "-"}
                      >
                        {normalizeProviderName(row.providerName) || "-"}

                      </TxtSpan>
                    </Div>
                  </TableBodyCell>

                  <TableBodyCell padding="10px 10px">
                    <TxtSpan color="#64748b" style={{ whiteSpace: "nowrap", fontSize: "11px", lineHeight: "14px", }}>
                      {/* {row.invoice_date || "-"} */}
                      {row.invoice_date
                        ? moment(row.invoice_date).format("MM-DD-YYYY")
                        : "-"}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="10px 10px">
                    <TxtSpan
                      color="#2b59ff"
                      fontWeight="500"
                      cursor="pointer"
                      style={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        fontSize: "11px",
                        lineHeight: "14px",
                      }}
                      title={row.invoice_id || "-"}
                    >
                      {row.invoice_id || "-"}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="10px 10px">
                    <TxtSpan
                      fontWeight="600"
                      color="#1e293b"
                      style={{
                        whiteSpace: "nowrap",
                        fontSize: "11px",
                        lineHeight: "14px",
                      }}
                    >
                      $
                      {parseFloat(
                        row.total_amount || row.total_balance || 0,
                      ).toFixed(2)}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="10px 10px">
                    <TxtSpan
                      fontWeight="600"
                      color="#1e293b"
                      style={{
                        whiteSpace: "nowrap",
                        fontSize: "11px",
                        lineHeight: "14px",
                      }}
                    >
                      ${parseFloat(row.total_balance || 0).toFixed(2)}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell
                    padding="18px 10px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ justifyContent: "center" }}
                  >
                    <NewStatusBadge status={getStatus(row)}>
                      {getStatus(row)}
                    </NewStatusBadge>
                  </TableBodyCell>

                  <TableBodyCell padding="18px 10px">
                    <Div
                      display="flex"
                      gap="10px"
                      justifyContent="center"
                      alignItems="center"
                      style={{ flexWrap: "nowrap" }}
                    >
                      <NewActionButton
                        variant="outline"
                        onClick={() => ViewInvoice(row)}
                        disabled={buttonDisable}
                      >
                        View
                      </NewActionButton>

                      <NewActionButton
                        onClick={() => InvoicePayment(row.invoice_id)}
                        disabled={
                          parseFloat(row.total_balance || 0) === 0 ||
                          getStatus(row) === "Paid" ||
                          btnDisable
                        }
                      >
                        <MdCreditCard /> Pay
                      </NewActionButton>
                    </Div>
                  </TableBodyCell>
                </TableRow>
              ))}
            </>
          ) : (
            <TableRow>
              <TableBodyCell colSpan={7} textAlign="center">
                <EmptyData />
              </TableBodyCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {MakePay && (
        <MakePayment
          show={MakePay}
          ModalHide={() => setMakePay(false)}
          makepayment="no"
          InvoiceList={OneInvoiceDetail}
          defaultcardcheck={DefaultCardDetails[0]}
          CardDetails={CardDetails}
          patient_balance={InvoiceBalanceAmt}
        />
      )}

      {invoiceModal && (
        <InvoicePopup
          show={invoiceModal}
          Data={invId}
          cardDetails={CardDetails}
          defaultcardcheck={DefaultCardDetails[0]}
          onHide={() => setInvoiceModal(false)}
        />
      )}

      {ModalAlerShow && (
        <StripeAlert show={ModalAlerShow} handleModalClick={handleModalClick} />
      )}
    </Div>
  );
};

export default InvoiceBalance;
